
angular.module('mtic.components.login')
.component('mticFinalization', {

  templateUrl: 'template.html',

  bindings: {
    roleType: '<',
    profile: '<'
  },

  controllerAs: 'user',

  controller(
    $scope, 
    $log, 
    language, 
    EventManager, 
    userAccount, 
    IAM_CODES, 
    LOGIN_CONSTANTS
  ) {

    // this
    const user = this;

    // event manager
    const eventManager = new EventManager('mticFinalization', $scope);

    // model
    $scope.language = language;
    $scope.logout = userAccount.logout;

    const setInfo = function() {
      setFlow();
      var userRoleType = user.roleType;
      var msfUser = user.profile;
      user.info = {
        firstName: msfUser.name.split(' ')[0],
        lastName: msfUser.name.split(' ').slice(1).join(' '),
        username: msfUser.unique_name,
        password: Math.random().toString(36).substr(3, 10),
        iam: msfUser.oid,
        iamUser: msfUser.unique_name
      }
      user.showOptions = true;
      if(userRoleType === LOGIN_CONSTANTS.ACCOUNT_TYPES.TEACHER) {
        user.flow.setType(IAM_CODES.LANG.TEACHER,'account')
        user.flow.isTesting = false;
      } 
      else if(userRoleType === LOGIN_CONSTANTS.ACCOUNT_TYPES.STUDENT) {
        user.flow.setType(IAM_CODES.LANG.STUDENT,'account')
        user.flow.isTesting = false;
      } 
      else {
        user.flow.setType(IAM_CODES.LANG.TEACHER,'account')
        user.flow.isTesting = true;
      }
      user.flow.setType(IAM_CODES.LANG.RETURNING,'returning')
    }

    const setFlow = function() {
      if(!user.flow) {
        user.flow = {
          summary: '',
          accountType: '',
          accountSelected: false,
          returningType: '',
          returningSelected: false,
          isTesting: true,
          setType: function (type, which) {
            user.flow[which + 'Type'] = type;
            user.flow[which + 'Selected'] = true;
            user.flow.setSummary();
          },
          setSummary: function () {
            if (user.flow.accountSelected) {
              user.flow.summary = ' ' + language.get(user.flow.accountType);
            }
            if (user.flow.returningSelected) {
              user.flow.summary += (' / ' + language.get(user.flow.returningType));
            }
          },
          setupBoxClass: function () {
            if (user.flow.accountSelected && user.flow.returningSelected) {
              return 'col-lg-5 col-md-6 col-sm-6 col-xs-6';
            } else {
              return 'col-md-6 col-md-offset-3';
            }
          }
        }
      }
    }

    user.$onInit = function() {
      setInfo();
    }

    this.$onChanges = function() {
      setInfo();
    }

  }
});
